module.exports = __webpack_public_path__ + "static/media/dongyanshan2.8ae4d81f.webp";